export default __webpack_public_path__ + "static/filtered-hero-de001f37e917a3abfeb049fd23058f78.png";